require('../../modules/es6.object.get-prototype-of');
module.exports = require('../../modules/_core').Object.getPrototypeOf;



//////////////////
// WEBPACK FOOTER
// /data/app/rdc-next/~/core-js/library/fn/object/get-prototype-of.js
// module id = 956
// module chunks = 48 49 50